import type { Product } from "@/types";

const LETTER_SIZES = ["PP", "P", "M", "G", "GG"];
const NUMBER_SIZES = ["36", "38", "40", "42", "44", "46"];

export const products: Product[] = [
  /* ---------------- BLUSAS ---------------- */
  {
    id: "blusa-essencial-sofia",
    code: "AMB-BLU-001",
    name: "Blusa Essencial Sofia",
    categoryId: "blusas",
    category: "Blusas",
    price: 139.9,
    promoPrice: 119.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizesOut: ["GG"],
    sizeGroup: "letter",
    tag: "Mais vendido",
    isNew: false,
    sold: 148,
    stock: 12,
    description:
      "Uma blusa coringa que combina com quase tudo. Tecido leve, caimento solto e aquele toque delicado que valoriza qualquer produção.",
    fabric: "Viscose com toque de seda",
    fit: "Modelagem solta com decote redondo suave",
    care: "Lavar à mão ou em ciclo delicado. Não usar alvejante.",
    colors: [
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20straight%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20plain%20off-white%20cream%20blouse%20with%20a%20soft%20round%20neckline%2C%20the%20blouse%20is%20clearly%20off-white%20cream%20colored%2C%20simple%20elegant%20feminine%20blouse%2C%20standing%20in%20a%20bright%20neutral%20studio%20with%20warm%20beige%20backdrop%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20calm%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-sofia-off&orientation=portrait&nocache=true",
      },
      {
        name: "Rosa queimado",
        hex: "#c07862",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20straight%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20plain%20blouse%20in%20vivid%20burnt%20rose%20pink%20color%20with%20a%20soft%20round%20neckline%2C%20the%20blouse%20is%20clearly%20strong%20pink%20burnt%20rose%20colored%2C%20same%20simple%20elegant%20feminine%20blouse%2C%20standing%20in%20a%20bright%20neutral%20studio%20with%20warm%20beige%20backdrop%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20calm%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-sofia-rosa&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "blusa-romantica-clara",
    code: "AMB-BLU-002",
    name: "Blusa Romântica Clara",
    categoryId: "blusas",
    category: "Blusas",
    price: 149.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    isNew: false,
    sold: 96,
    stock: 9,
    description:
      "Detalhes suaves e tecido fluido para um ar romântico sem exageros. Combina lindamente com calças e saias.",
    fabric: "Crepe leve com textura delicada",
    fit: "Modelagem fluida com mangas levemente soltas",
    care: "Lavar à mão. Secar à sombra para preservar o tecido.",
    colors: [
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20voluminous%20curly%20hair%20and%20deep%20skin%20wearing%20a%20romantic%20off-white%20cream%20blouse%20with%20soft%20ruffles%2C%20the%20blouse%20is%20clearly%20off-white%20cream%20colored%2C%20feminine%20ruffled%20blouse%2C%20standing%20in%20a%20warm%20cozy%20interior%20with%20beige%20walls%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20gentle%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-clara-off&orientation=portrait&nocache=true",
      },
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20voluminous%20curly%20hair%20and%20deep%20skin%20wearing%20a%20romantic%20blouse%20with%20soft%20ruffles%20in%20deep%20plum%20ameixa%20color%2C%20the%20blouse%20is%20clearly%20dark%20plum%20purple-burgundy%20colored%2C%20same%20feminine%20ruffled%20blouse%2C%20standing%20in%20a%20warm%20cozy%20interior%20with%20beige%20walls%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20gentle%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-clara-ameixa&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "blusa-manga-bufante-beatriz",
    code: "AMB-BLU-003",
    name: "Blusa Manga Bufante Beatriz",
    categoryId: "blusas",
    category: "Blusas",
    price: 159.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizesOut: ["PP"],
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 41,
    stock: 7,
    description:
      "Mangas bufantes delicadas e um caimento que valoriza os ombros. Um charme a mais para o seu dia.",
    fabric: "Tecido plano com leve estrutura",
    fit: "Modelagem ajustada no corpo com mangas amplas",
    care: "Lavar à mão ou a seco. Passar em temperatura baixa.",
    colors: [
      {
        name: "Areia",
        hex: "#cbb79a",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20light%20brown%20hair%20and%20light%20skin%20wearing%20a%20blouse%20with%20clearly%20puffed%20voluminous%20sleeves%20in%20sand%20beige%20color%2C%20the%20blouse%20is%20clearly%20light%20sand%20beige%20colored%2C%20feminine%20blouse%20with%20big%20puffed%20bishop%20sleeves%2C%20standing%20in%20a%20bright%20minimal%20studio%20with%20warm%20neutral%20background%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-beatriz-areia&orientation=portrait&nocache=true",
      },
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20light%20brown%20hair%20and%20light%20skin%20wearing%20a%20blouse%20with%20clearly%20puffed%20voluminous%20sleeves%20in%20soft%20black%20color%2C%20the%20blouse%20is%20clearly%20black%20colored%2C%20same%20feminine%20blouse%20with%20big%20puffed%20bishop%20sleeves%2C%20standing%20in%20a%20bright%20minimal%20studio%20with%20warm%20neutral%20background%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-beatriz-preto&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "blusa-leve-cecilia",
    code: "AMB-BLU-004",
    name: "Blusa Leve Cecília",
    categoryId: "blusas",
    category: "Blusas",
    price: 169.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 33,
    stock: 6,
    description:
      "Leve, delicada e fácil de combinar, a Blusa Cecília acompanha o trabalho, os encontros e os momentos mais tranquilos com conforto e elegância.",
    fabric: "Linho misto com toque macio",
    fit: "Modelagem levemente solta, com caimento suave e acabamento feminino.",
    care: "Lavar à mão. Passar levemente úmida para alisar.",
    colors: [
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20dark%20hair%20and%20medium%20skin%20wearing%20a%20lightweight%20feminine%20blouse%20in%20off-white%20cream%20with%20a%20soft%20rounded%20neckline%20and%20flowing%20fabric%2C%20the%20blouse%20is%20clearly%20off-white%20cream%20colored%2C%20delicate%20feminine%20blouse%20not%20a%20masculine%20button-up%20shirt%2C%20standing%20in%20a%20bright%20modern%20urban%20lobby%20with%20warm%20neutral%20walls%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-cecilia-off&orientation=portrait&nocache=true",
      },
      {
        name: "Camelo",
        hex: "#b08968",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20dark%20hair%20and%20medium%20skin%20wearing%20a%20lightweight%20feminine%20blouse%20in%20warm%20camel%20brown%20with%20a%20soft%20rounded%20neckline%20and%20flowing%20fabric%2C%20the%20blouse%20is%20clearly%20camel%20brown%20colored%2C%20delicate%20feminine%20blouse%20not%20a%20masculine%20button-up%20shirt%2C%20standing%20in%20a%20bright%20modern%20urban%20lobby%20with%20warm%20neutral%20walls%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-cecilia-camelo&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "blusa-canelada-isadora",
    code: "AMB-BLU-005",
    name: "Blusa Canelada Isadora",
    categoryId: "blusas",
    category: "Blusas",
    price: 129.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 27,
    stock: 11,
    description:
      "Tecido canelado que abraça o corpo com conforto. Uma peça básica que nunca sai de moda e combina com tudo.",
    fabric: "Malha canelada com elastano",
    fit: "Modelagem justa e confortável",
    care: "Lavar à mão. Não passar a ferro em temperatura alta.",
    colors: [
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20curly%20dark%20hair%20and%20deep%20skin%20wearing%20a%20fitted%20ribbed%20knit%20top%20with%20clearly%20visible%20ribbed%20vertical%20texture%20in%20deep%20plum%20ameixa%20color%2C%20the%20top%20is%20clearly%20dark%20plum%20purple-burgundy%20colored%2C%20canelada%20ribbed%20fabric%2C%20standing%20in%20a%20warm%20minimal%20studio%20with%20beige%20backdrop%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20serene%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-isadora-ameixa&orientation=portrait&nocache=true",
      },
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20curly%20dark%20hair%20and%20deep%20skin%20wearing%20a%20fitted%20ribbed%20knit%20top%20with%20clearly%20visible%20ribbed%20vertical%20texture%20in%20light%20beige%20color%2C%20the%20top%20is%20clearly%20light%20beige%20cream%20colored%2C%20canelada%20ribbed%20fabric%2C%20standing%20in%20a%20warm%20minimal%20studio%20with%20beige%20backdrop%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20serene%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-blu-isadora-bege&orientation=portrait&nocache=true",
      },
    ],
  },

  /* ---------------- CALÇAS ---------------- */
  {
    id: "calca-alfaiataria-helena",
    code: "AMB-CAL-001",
    name: "Calça Alfaiataria Helena",
    categoryId: "calcas",
    category: "Calças",
    price: 259.9,
    installments: 3,
    sizes: NUMBER_SIZES,
    sizesOut: ["46"],
    sizeGroup: "number",
    tag: "Mais vendido",
    isNew: false,
    sold: 132,
    stock: 10,
    description:
      "Alfaiataria impecável para o trabalho e para além dele. Marca a cintura, alonga a silhueta e garante conforto o dia inteiro.",
    fabric: "Crepe de alfaiataria com elastano",
    fit: "Cintura alta com caimento reto e elegante",
    care: "Lavar à mão ou a seco. Passar em temperatura média.",
    colors: [
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20medium%20skin%20wearing%20high%20waist%20tailored%20trousers%20in%20coffee%20brown%2C%20full%20length%20long%20pants%20reaching%20the%20ankles%20clearly%20visible%2C%20the%20trousers%20are%20clearly%20coffee%20brown%20colored%2C%20structured%20tailoring%2C%20with%20a%20simple%20silk%20top%2C%20standing%20in%20a%20modern%20office%20with%20warm%20neutral%20interiors%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-helena-marrom&orientation=portrait&nocache=true",
      },
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20medium%20skin%20wearing%20high%20waist%20tailored%20trousers%20in%20soft%20black%2C%20full%20length%20long%20pants%20reaching%20the%20ankles%20clearly%20visible%2C%20the%20trousers%20are%20clearly%20black%20colored%2C%20structured%20tailoring%2C%20with%20a%20simple%20silk%20top%2C%20standing%20in%20a%20modern%20office%20with%20warm%20neutral%20interiors%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-helena-preto&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "calca-pantalona-valentina",
    code: "AMB-CAL-002",
    name: "Calça Pantalona Valentina",
    categoryId: "calcas",
    category: "Calças",
    price: 269.9,
    installments: 3,
    sizes: NUMBER_SIZES,
    sizeGroup: "number",
    tag: "Destaque",
    isNew: false,
    sold: 87,
    stock: 8,
    description:
      "Modelagem ampla e sofisticada que alonga a silhueta. Conforto de sobra com uma elegância que chama atenção.",
    fabric: "Crepe fluido com boa caída",
    fit: "Pantalona ampla de cintura alta",
    care: "Lavar à mão. Secar à sombra.",
    colors: [
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20hair%20and%20light%20skin%20wearing%20wide%20leg%20palazzo%20trousers%20with%20very%20wide%20flowing%20legs%2C%20full%20length%20long%20pants%20reaching%20the%20ankles%2C%20the%20palazzo%20trousers%20are%20clearly%20black%20colored%2C%20with%20a%20fitted%20top%2C%20standing%20in%20an%20elegant%20urban%20interior%20with%20warm%20neutral%20walls%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-valentina-preto&orientation=portrait&nocache=true",
      },
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20hair%20and%20light%20skin%20wearing%20wide%20leg%20palazzo%20trousers%20with%20very%20wide%20flowing%20legs%2C%20full%20length%20long%20pants%20reaching%20the%20ankles%2C%20the%20palazzo%20trousers%20are%20clearly%20light%20beige%20cream%20colored%2C%20with%20a%20fitted%20top%2C%20standing%20in%20an%20elegant%20urban%20interior%20with%20warm%20neutral%20walls%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-valentina-bege&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "calca-reta-laura",
    code: "AMB-CAL-003",
    name: "Calça Reta Laura",
    categoryId: "calcas",
    category: "Calças",
    price: 239.9,
    promoPrice: 199.9,
    installments: 3,
    sizes: NUMBER_SIZES,
    sizeGroup: "number",
    isNew: false,
    sold: 74,
    stock: 13,
    description:
      "Caimento reto e atemporal, do trabalho ao fim de semana. Uma calça que veste bem e combina com tudo.",
    fabric: "Sarja leve com toque macio",
    fit: "Corte reto com cintura média",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20warm%20medium%20skin%20wearing%20straight%20cut%20trousers%20straight%20full%20length%20long%20pants%20reaching%20the%20ankles%2C%20the%20trousers%20are%20clearly%20light%20beige%20cream%20colored%2C%20with%20a%20knit%20top%2C%20standing%20on%20an%20elegant%20sunlit%20urban%20street%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-laura-bege&orientation=portrait&nocache=true",
      },
      {
        name: "Camelo",
        hex: "#b08968",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20warm%20medium%20skin%20wearing%20straight%20cut%20trousers%20straight%20full%20length%20long%20pants%20reaching%20the%20ankles%2C%20the%20trousers%20are%20clearly%20warm%20camel%20brown%20colored%2C%20with%20a%20knit%20top%2C%20standing%20on%20an%20elegant%20sunlit%20urban%20street%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-laura-camelo&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "calca-wide-leg-antonella",
    code: "AMB-CAL-004",
    name: "Calça Wide Leg Antonella",
    categoryId: "calcas",
    category: "Calças",
    price: 279.9,
    installments: 3,
    sizes: NUMBER_SIZES,
    sizesOut: ["36"],
    sizeGroup: "number",
    tag: "Novo",
    isNew: true,
    sold: 38,
    stock: 6,
    description:
      "Pernas amplas e movimento leve que dá aquele ar moderno. Perfeita para compor looks elegantes com facilidade.",
    fabric: "Linho misto com toque seco",
    fit: "Wide leg de cintura alta",
    care: "Lavar à mão. Secar à sombra para manter a caída.",
    colors: [
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20curly%20hair%20and%20deep%20skin%20wearing%20wide%20leg%20linen%20trousers%20with%20broad%20straight%20legs%20full%20length%20long%20pants%20reaching%20the%20ankles%2C%20the%20trousers%20are%20clearly%20coffee%20brown%20colored%20with%20visible%20linen%20texture%2C%20with%20a%20light%20blouse%2C%20standing%20in%20a%20sunlit%20modern%20lounge%20with%20warm%20neutral%20tones%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-antonella-marrom&orientation=portrait&nocache=true",
      },
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20curly%20hair%20and%20deep%20skin%20wearing%20wide%20leg%20linen%20trousers%20with%20broad%20straight%20legs%20full%20length%20long%20pants%20reaching%20the%20ankles%2C%20the%20trousers%20are%20clearly%20off-white%20cream%20colored%20with%20visible%20linen%20texture%2C%20with%20a%20light%20blouse%2C%20standing%20in%20a%20sunlit%20modern%20lounge%20with%20warm%20neutral%20tones%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-antonella-off&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "calca-cenoura-gabriela",
    code: "AMB-CAL-005",
    name: "Calça Cenoura Gabriela",
    categoryId: "calcas",
    category: "Calças",
    price: 229.9,
    installments: 3,
    sizes: NUMBER_SIZES,
    sizeGroup: "number",
    isNew: false,
    sold: 61,
    stock: 9,
    description:
      "Modelagem cenoura que afina a silhueta e valoriza a cintura. Confortável e cheia de personalidade.",
    fabric: "Crepe estruturado com elastano",
    fit: "Cintura alta ajustada com pernas afuniladas",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20light%20brown%20hair%20and%20light%20skin%20wearing%20high%20waist%20tapered%20carrot%20trousers%20with%20legs%20narrowing%20toward%20the%20ankle%20full%20length%20long%20pants%2C%20the%20trousers%20are%20clearly%20black%20colored%2C%20with%20a%20tucked%20blouse%2C%20standing%20on%20a%20warm%20urban%20street%20with%20soft%20afternoon%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-gabriela-preto&orientation=portrait&nocache=true",
      },
      {
        name: "Terracota",
        hex: "#a9694f",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20light%20brown%20hair%20and%20light%20skin%20wearing%20high%20waist%20tapered%20carrot%20trousers%20with%20legs%20narrowing%20toward%20the%20ankle%20full%20length%20long%20pants%2C%20the%20trousers%20are%20clearly%20warm%20terracotta%20orange-brown%20colored%2C%20with%20a%20tucked%20blouse%2C%20standing%20on%20a%20warm%20urban%20street%20with%20soft%20afternoon%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-cal-gabriela-terracota&orientation=portrait&nocache=true",
      },
    ],
  },

  /* ---------------- VESTIDOS ---------------- */
  {
    id: "vestido-midi-serena",
    code: "AMB-VES-001",
    name: "Vestido Midi Serena",
    categoryId: "vestidos",
    category: "Vestidos",
    price: 289.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Destaque",
    isNew: false,
    sold: 118,
    stock: 8,
    description:
      "Caimento fluido e feminino, perfeito para compromissos, almoços especiais e dias em que você quer se sentir elegante sem esforço.",
    fabric: "Viscose fluida com toque fresco",
    fit: "Midi com caimento solto e leve",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20an%20elegant%20midi%20dress%20that%20clearly%20ends%20below%20the%20knee%2C%20the%20dress%20is%20clearly%20deep%20plum%20ameixa%20purple-burgundy%20colored%20with%20soft%20draping%2C%20one%20single%20dress%20garment%2C%20standing%20in%20a%20warm%20studio%20with%20beige%20backdrop%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20calm%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-serena-ameixa&orientation=portrait&nocache=true",
      },
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20an%20elegant%20midi%20dress%20that%20clearly%20ends%20below%20the%20knee%2C%20the%20dress%20is%20clearly%20off-white%20cream%20colored%20with%20soft%20draping%2C%20one%20single%20dress%20garment%2C%20standing%20in%20a%20warm%20studio%20with%20beige%20backdrop%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20calm%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-serena-off&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "vestido-floral-manuela",
    code: "AMB-VES-002",
    name: "Vestido Floral Manuela",
    categoryId: "vestidos",
    category: "Vestidos",
    price: 299.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Mais vendido",
    isNew: false,
    sold: 141,
    stock: 7,
    description:
      "Estampa floral delicada e modelagem romântica. Perfeito para almoços, passeios e ocasiões que pedem leveza.",
    fabric: "Viscose estampada com toque de seda",
    fit: "Midi com alça e caimento fluido",
    care: "Lavar à mão com cores semelhantes.",
    colors: [
      {
        name: "Floral rosé",
        hex: "#c98f88",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20curly%20brown%20hair%20and%20light%20skin%20wearing%20a%20midi%20dress%20with%20a%20clearly%20visible%20floral%20print%20pattern%20in%20soft%20rose%20pink%20tones%2C%20one%20single%20dress%20garment%20with%20a%20delicate%20flower%20pattern%2C%20standing%20in%20a%20sunlit%20garden%20with%20blurred%20greenery%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20happy%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-manuela-rose&orientation=portrait&nocache=true",
      },
      {
        name: "Floral vinho",
        hex: "#6b2338",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20curly%20brown%20hair%20and%20light%20skin%20wearing%20a%20midi%20dress%20with%20a%20clearly%20visible%20floral%20print%20pattern%20in%20deep%20wine%20burgundy%20tones%2C%20one%20single%20dress%20garment%20with%20a%20delicate%20flower%20pattern%2C%20standing%20in%20a%20sunlit%20garden%20with%20blurred%20greenery%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20happy%20natural%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-manuela-vinho&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "vestido-chemise-livia",
    code: "AMB-VES-003",
    name: "Vestido Chemise Lívia",
    categoryId: "vestidos",
    category: "Vestidos",
    price: 279.9,
    promoPrice: 239.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizesOut: ["GG"],
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 35,
    stock: 9,
    description:
      "Estilo camisaria despojado e confortável, com botões frontais e caimento solto. Fácil de usar em qualquer dia.",
    fabric: "Tencel com toque macio",
    fit: "Chemise solta com cinto opcional",
    care: "Lavar à mão ou em ciclo delicado.",
    colors: [
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20shoulder%20length%20wavy%20hair%20and%20medium%20skin%20wearing%20a%20relaxed%20shirt%20dress%20with%20front%20buttons%20that%20clearly%20reaches%20midi%20length%20below%20the%20knee%2C%20the%20dress%20is%20clearly%20off-white%20cream%20colored%2C%20one%20single%20long%20dress%20not%20a%20blouse%2C%20standing%20in%20a%20bright%20warm%20interior%20with%20soft%20neutral%20walls%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-livia-off&orientation=portrait&nocache=true",
      },
      {
        name: "Areia",
        hex: "#cbb79a",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20shoulder%20length%20wavy%20hair%20and%20medium%20skin%20wearing%20a%20relaxed%20shirt%20dress%20with%20front%20buttons%20that%20clearly%20reaches%20midi%20length%20below%20the%20knee%2C%20the%20dress%20is%20clearly%20sand%20beige%20colored%2C%20one%20single%20long%20dress%20not%20a%20blouse%2C%20standing%20in%20a%20bright%20warm%20interior%20with%20soft%20neutral%20walls%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-livia-areia&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "vestido-longo-maite",
    code: "AMB-VES-004",
    name: "Vestido Longo Maitê",
    categoryId: "vestidos",
    category: "Vestidos",
    price: 339.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 29,
    stock: 5,
    description:
      "Longo, elegante e cheio de presença. Uma peça para os momentos especiais em que você quer se sentir ainda mais bonita.",
    fabric: "Crepe encorpado com forro",
    fit: "Longo com caimento fluido e cintura marcada",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Vinho",
        hex: "#6b2338",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20straight%20black%20hair%20and%20deep%20skin%20wearing%20an%20elegant%20floor%20length%20long%20dress%20that%20clearly%20reaches%20the%20floor%2C%20the%20dress%20is%20clearly%20rich%20wine%20burgundy%20colored%20with%20soft%20draping%2C%20one%20single%20long%20dress%20garment%2C%20standing%20in%20a%20warm%20elegant%20lounge%20with%20neutral%20decor%2C%20soft%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-maite-vinho&orientation=portrait&nocache=true",
      },
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20straight%20black%20hair%20and%20deep%20skin%20wearing%20an%20elegant%20floor%20length%20long%20dress%20that%20clearly%20reaches%20the%20floor%2C%20the%20dress%20is%20clearly%20coffee%20brown%20colored%20with%20soft%20draping%2C%20one%20single%20long%20dress%20garment%2C%20standing%20in%20a%20warm%20elegant%20lounge%20with%20neutral%20decor%2C%20soft%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-maite-marrom&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "vestido-transpassado-olivia",
    code: "AMB-VES-005",
    name: "Vestido Transpassado Olívia",
    categoryId: "vestidos",
    category: "Vestidos",
    price: 319.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Destaque",
    isNew: false,
    sold: 82,
    stock: 6,
    description:
      "Transpassado que valoriza a cintura e cria um decote elegante. Sofisticado e fácil de amar.",
    fabric: "Crepe com leve elasticidade",
    fit: "Transpassado com amarração na cintura",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Terracota",
        hex: "#a9694f",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20wrap%20midi%20dress%20with%20a%20crossed%20V%20neckline%20and%20a%20tie%20waist%20ending%20below%20the%20knee%2C%20the%20dress%20is%20clearly%20warm%20terracotta%20orange-brown%20colored%2C%20one%20single%20dress%20garment%2C%20standing%20on%20an%20elegant%20city%20street%20at%20dusk%20with%20warm%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-olivia-terracota&orientation=portrait&nocache=true",
      },
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20wrap%20midi%20dress%20with%20a%20crossed%20V%20neckline%20and%20a%20tie%20waist%20ending%20below%20the%20knee%2C%20the%20dress%20is%20clearly%20black%20colored%2C%20one%20single%20dress%20garment%2C%20standing%20on%20an%20elegant%20city%20street%20at%20dusk%20with%20warm%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ves-olivia-preto&orientation=portrait&nocache=true",
      },
    ],
  },

  /* ---------------- MACACÕES ---------------- */
  {
    id: "macacao-elegancia",
    code: "AMB-MAC-001",
    name: "Macacão Elegância",
    categoryId: "macacoes",
    category: "Macacões",
    price: 279.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Mais vendido",
    isNew: false,
    sold: 126,
    stock: 8,
    description:
      "A peça única que resolve o look inteiro. Elegante, prática e feita para acompanhar você do escritório ao jantar.",
    fabric: "Crepe de alfaiataria leve",
    fit: "Perna ampla com cintura marcada",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20chic%20wide%20leg%20jumpsuit%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20deep%20plum%20ameixa%20purple-burgundy%20colored%2C%20standing%20in%20an%20elegant%20warm%20lounge%20with%20beige%20interior%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20graceful%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-elegancia-ameixa&orientation=portrait&nocache=true",
      },
      {
        name: "Terracota",
        hex: "#a9694f",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20chic%20wide%20leg%20jumpsuit%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20warm%20terracotta%20orange-brown%20colored%2C%20standing%20in%20an%20elegant%20warm%20lounge%20with%20beige%20interior%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20graceful%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-elegancia-terracota&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "macacao-leve-marina",
    code: "AMB-MAC-002",
    name: "Macacão Leve Marina",
    categoryId: "macacoes",
    category: "Macacões",
    price: 259.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    isNew: false,
    sold: 69,
    stock: 10,
    description:
      "Tecido fresco e modelagem solta para os dias em que você quer praticidade sem abrir mão do estilo.",
    fabric: "Linho misto respirável",
    fit: "Modelagem solta com alças ajustáveis",
    care: "Lavar à mão. Secar à sombra.",
    colors: [
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20curly%20hair%20and%20deep%20skin%20wearing%20a%20relaxed%20jumpsuit%20with%20adjustable%20straps%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20off-white%20cream%20colored%2C%20standing%20on%20a%20sunlit%20terrace%20with%20neutral%20stone%20walls%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20easy%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-marina-off&orientation=portrait&nocache=true",
      },
      {
        name: "Terracota",
        hex: "#a9694f",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20curly%20hair%20and%20deep%20skin%20wearing%20a%20relaxed%20jumpsuit%20with%20adjustable%20straps%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20warm%20terracotta%20orange-brown%20colored%2C%20standing%20on%20a%20sunlit%20terrace%20with%20neutral%20stone%20walls%2C%20soft%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20easy%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-marina-terracota&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "macacao-pantalona-lorena",
    code: "AMB-MAC-003",
    name: "Macacão Pantalona Lorena",
    categoryId: "macacoes",
    category: "Macacões",
    price: 299.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizesOut: ["GG"],
    sizeGroup: "letter",
    tag: "Destaque",
    isNew: false,
    sold: 77,
    stock: 6,
    description:
      "Pernas amplas e alongadas com um caimento que impressiona. Sofisticação com muito conforto.",
    fabric: "Crepe fluido de alfaiataria",
    fit: "Pantalona ampla com faixa na cintura",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20medium%20skin%20wearing%20a%20wide%20leg%20palazzo%20jumpsuit%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20black%20colored%2C%20standing%20in%20a%20modern%20office%20with%20warm%20neutral%20interiors%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-lorena-preto&orientation=portrait&nocache=true",
      },
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20medium%20skin%20wearing%20a%20wide%20leg%20palazzo%20jumpsuit%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20coffee%20brown%20colored%2C%20standing%20in%20a%20modern%20office%20with%20warm%20neutral%20interiors%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-lorena-marrom&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "macacao-faixa-camila",
    code: "AMB-MAC-004",
    name: "Macacão Faixa Camila",
    categoryId: "macacoes",
    category: "Macacões",
    price: 269.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 30,
    stock: 7,
    description:
      "Faixa amarrada na cintura que marca a silhueta com delicadeza. Prático de vestir e cheio de charme.",
    fabric: "Tecido plano com leve estrutura",
    fit: "Modelagem ajustada com faixa na cintura",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20light%20brown%20hair%20and%20light%20skin%20wearing%20a%20belted%20jumpsuit%20with%20a%20fabric%20belt%20tied%20at%20the%20waist%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20light%20beige%20colored%2C%20standing%20in%20a%20bright%20warm%20interior%20with%20soft%20neutral%20walls%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-camila-bege&orientation=portrait&nocache=true",
      },
      {
        name: "Rosa queimado",
        hex: "#c07862",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20wavy%20light%20brown%20hair%20and%20light%20skin%20wearing%20a%20belted%20jumpsuit%20with%20a%20fabric%20belt%20tied%20at%20the%20waist%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20vivid%20burnt%20rose%20pink%20colored%2C%20standing%20in%20a%20bright%20warm%20interior%20with%20soft%20neutral%20walls%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-camila-rosa&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "macacao-alfaiataria-elisa",
    code: "AMB-MAC-005",
    name: "Macacão Alfaiataria Elisa",
    categoryId: "macacoes",
    category: "Macacões",
    price: 309.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    isNew: false,
    sold: 58,
    stock: 6,
    description:
      "Estrutura de alfaiataria em um macacão que veste com personalidade. Ideal para reuniões e compromissos importantes.",
    fabric: "Alfaiataria estruturada",
    fit: "Modelagem reta com decote transpassado",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20dark%20hair%20and%20medium%20skin%20wearing%20a%20tailored%20jumpsuit%20with%20a%20crossed%20wrap%20neckline%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20coffee%20brown%20colored%2C%20standing%20on%20an%20elegant%20urban%20street%20with%20warm%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-elisa-marrom&orientation=portrait&nocache=true",
      },
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20dark%20hair%20and%20medium%20skin%20wearing%20a%20tailored%20jumpsuit%20with%20a%20crossed%20wrap%20neckline%2C%20one%20single%20full%20body%20one%20piece%20garment%20covering%20torso%20and%20legs%20together%2C%20the%20jumpsuit%20is%20clearly%20black%20colored%2C%20standing%20on%20an%20elegant%20urban%20street%20with%20warm%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-mac-elisa-preto&orientation=portrait&nocache=true",
      },
    ],
  },

  /* ---------------- BERMUDAS ---------------- */
  {
    id: "bermuda-linho-aurora",
    code: "AMB-BER-001",
    name: "Bermuda Linho Aurora",
    categoryId: "bermudas",
    category: "Bermudas",
    price: 189.9,
    installments: 2,
    sizes: NUMBER_SIZES,
    sizeGroup: "number",
    tag: "Mais vendido",
    isNew: false,
    sold: 111,
    stock: 10,
    description:
      "Linho leve e fresco, com caimento reto que valoriza a silhueta. Ideal para dias quentes com muito estilo.",
    fabric: "Linho misto fresco",
    fit: "Cintura alta com caimento reto",
    care: "Lavar à mão. Passar levemente úmida.",
    colors: [
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20warm%20medium%20skin%20wearing%20short%20linen%20bermuda%20shorts%20whose%20hem%20clearly%20ends%20mid%20thigh%20well%20above%20the%20knee%20with%20bare%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20light%20beige%20cream%20colored%20with%20visible%20linen%20texture%2C%20with%20a%20flowy%20top%2C%20standing%20on%20a%20sunlit%20urban%20sidewalk%20with%20warm%20neutral%20walls%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20relaxed%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-aurora-bege&orientation=portrait&nocache=true",
      },
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20warm%20medium%20skin%20wearing%20short%20linen%20bermuda%20shorts%20whose%20hem%20clearly%20ends%20mid%20thigh%20well%20above%20the%20knee%20with%20bare%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20off-white%20cream%20colored%20with%20visible%20linen%20texture%2C%20with%20a%20flowy%20top%2C%20standing%20on%20a%20sunlit%20urban%20sidewalk%20with%20warm%20neutral%20walls%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20relaxed%20expression%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-aurora-off&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "bermuda-alfaiataria-bianca",
    code: "AMB-BER-002",
    name: "Bermuda Alfaiataria Bianca",
    categoryId: "bermudas",
    category: "Bermudas",
    price: 199.9,
    installments: 2,
    sizes: NUMBER_SIZES,
    sizeGroup: "number",
    tag: "Destaque",
    isNew: false,
    sold: 84,
    stock: 8,
    description:
      "Alfaiataria bem estruturada que transita do trabalho ao fim de semana com elegância e conforto.",
    fabric: "Crepe de alfaiataria",
    fit: "Corte reto com pregas frontais",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20light%20skin%20wearing%20structured%20tailored%20bermuda%20shorts%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20black%20colored%20with%20front%20pleats%2C%20with%20a%20tucked%20silk%20blouse%2C%20standing%20in%20a%20bright%20neutral%20studio%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-bianca-preto&orientation=portrait&nocache=true",
      },
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20light%20skin%20wearing%20structured%20tailored%20bermuda%20shorts%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20coffee%20brown%20colored%20with%20front%20pleats%2C%20with%20a%20tucked%20silk%20blouse%2C%20standing%20in%20a%20bright%20neutral%20studio%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-bianca-marrom&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "bermuda-cintura-alta-marina",
    code: "AMB-BER-003",
    name: "Bermuda Cintura Alta Marina",
    categoryId: "bermudas",
    category: "Bermudas",
    price: 179.9,
    installments: 2,
    sizes: NUMBER_SIZES,
    sizeGroup: "number",
    isNew: false,
    sold: 66,
    stock: 12,
    description:
      "Cintura alta que marca a silhueta e alonga as pernas. Uma bermuda versátil para os dias mais quentes.",
    fabric: "Sarja leve com elastano",
    fit: "Cintura alta com caimento reto",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Areia",
        hex: "#cbb79a",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20curly%20dark%20hair%20and%20deep%20skin%20wearing%20high%20waist%20bermuda%20shorts%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20sand%20beige%20colored%2C%20with%20a%20light%20top%2C%20standing%20on%20a%20warm%20urban%20street%20with%20soft%20afternoon%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20natural%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-marina-areia&orientation=portrait&nocache=true",
      },
      {
        name: "Terracota",
        hex: "#a9694f",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20curly%20dark%20hair%20and%20deep%20skin%20wearing%20high%20waist%20bermuda%20shorts%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20warm%20terracotta%20orange-brown%20colored%2C%20with%20a%20light%20top%2C%20standing%20on%20a%20warm%20urban%20street%20with%20soft%20afternoon%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20natural%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-marina-terracota&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "bermuda-casual-luna",
    code: "AMB-BER-004",
    name: "Bermuda Casual Luna",
    categoryId: "bermudas",
    category: "Bermudas",
    price: 169.9,
    promoPrice: 139.9,
    installments: 2,
    sizes: NUMBER_SIZES,
    sizeGroup: "number",
    isNew: false,
    sold: 92,
    stock: 14,
    description:
      "Conforto macio e visual moderno para o dia a dia. Ótima para passeios, viagens e dias tranquilos.",
    fabric: "Moletom leve com toque macio",
    fit: "Modelagem solta com elástico e cordão",
    care: "Lavar à mão. Secar à sombra.",
    colors: [
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20wavy%20hair%20and%20medium%20skin%20wearing%20comfortable%20casual%20bermuda%20shorts%20with%20an%20elastic%20waistband%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20coffee%20brown%20colored%2C%20with%20a%20soft%20knit%20top%2C%20standing%20in%20a%20cozy%20sunlit%20interior%20with%20warm%20beige%20tones%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-luna-marrom&orientation=portrait&nocache=true",
      },
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20wavy%20hair%20and%20medium%20skin%20wearing%20comfortable%20casual%20bermuda%20shorts%20with%20an%20elastic%20waistband%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20light%20beige%20colored%2C%20with%20a%20soft%20knit%20top%2C%20standing%20in%20a%20cozy%20sunlit%20interior%20with%20warm%20beige%20tones%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-luna-bege&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "bermuda-clochard-cecilia",
    code: "AMB-BER-005",
    name: "Bermuda Clochard Cecília",
    categoryId: "bermudas",
    category: "Bermudas",
    price: 209.9,
    installments: 2,
    sizes: NUMBER_SIZES,
    sizesOut: ["36"],
    sizeGroup: "number",
    tag: "Novo",
    isNew: true,
    sold: 25,
    stock: 6,
    description:
      "Modelagem clochard ampla e sofisticada, com caimento que dá movimento ao look. Elegância descomplicada.",
    fabric: "Crepe fluido com boa caída",
    fit: "Clochard ampla de cintura alta",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Camelo",
        hex: "#b08968",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20wavy%20hair%20and%20light%20skin%20wearing%20wide%20clochard%20bermuda%20shorts%20with%20a%20loose%20wide%20leg%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20camel%20brown%20colored%2C%20with%20a%20fitted%20top%2C%20standing%20on%20an%20elegant%20urban%20street%20with%20warm%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-cecilia-camelo&orientation=portrait&nocache=true",
      },
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20wavy%20hair%20and%20light%20skin%20wearing%20wide%20clochard%20bermuda%20shorts%20with%20a%20loose%20wide%20leg%20whose%20hem%20clearly%20ends%20above%20the%20knee%20with%20the%20legs%20and%20knees%20fully%20visible%2C%20not%20trousers%20not%20long%20pants%2C%20the%20shorts%20are%20clearly%20black%20colored%2C%20with%20a%20fitted%20top%2C%20standing%20on%20an%20elegant%20urban%20street%20with%20warm%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-ber-cecilia-preto&orientation=portrait&nocache=true",
      },
    ],
  },

  /* ---------------- CONJUNTOS ---------------- */
  {
    id: "conjunto-iris",
    code: "AMB-CON-001",
    name: "Conjunto Íris",
    categoryId: "conjuntos",
    category: "Conjuntos",
    price: 319.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Mais vendido",
    isNew: false,
    sold: 104,
    stock: 7,
    description:
      "Conjunto versátil que veste bem de manhã até a noite. Combine as peças juntas ou separe para multiplicar as produções.",
    fabric: "Crepe leve com toque fresco",
    fit: "Top e calça de cintura média",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Rosa queimado",
        hex: "#c07862",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20warm%20medium%20skin%20wearing%20a%20matching%20two%20piece%20set%20made%20of%20a%20coordinated%20top%20and%20trousers%20in%20the%20same%20fabric%2C%20the%20whole%20set%20is%20clearly%20vivid%20burnt%20rose%20pink%20colored%2C%20two%20matching%20garments%2C%20standing%20in%20a%20cozy%20cafe%20with%20warm%20ambient%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20welcoming%20smile%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-iris-rosa&orientation=portrait&nocache=true",
      },
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20warm%20medium%20skin%20wearing%20a%20matching%20two%20piece%20set%20made%20of%20a%20coordinated%20top%20and%20trousers%20in%20the%20same%20fabric%2C%20the%20whole%20set%20is%20clearly%20deep%20plum%20ameixa%20purple-burgundy%20colored%2C%20two%20matching%20garments%2C%20standing%20in%20a%20cozy%20cafe%20with%20warm%20ambient%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20welcoming%20smile%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-iris-ameixa&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "conjunto-casual-luna",
    code: "AMB-CON-002",
    name: "Conjunto Casual Luna",
    categoryId: "conjuntos",
    category: "Conjuntos",
    price: 309.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Destaque",
    isNew: false,
    sold: 89,
    stock: 9,
    description:
      "Conforto macio e visual moderno para o dia a dia. Ótimo para viagens, encontros casuais e dias tranquilos.",
    fabric: "Malha macia com elastano",
    fit: "Modelagem solta e confortável",
    care: "Lavar à mão. Secar à sombra.",
    colors: [
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20shoulder%20length%20dark%20hair%20and%20medium%20skin%20wearing%20a%20casual%20matching%20two%20piece%20set%20with%20a%20coordinated%20knit%20top%20and%20knit%20trousers%20in%20the%20same%20fabric%2C%20the%20whole%20set%20is%20clearly%20coffee%20brown%20colored%2C%20two%20matching%20knit%20garments%2C%20standing%20in%20a%20cozy%20sunlit%20interior%20with%20warm%20beige%20tones%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20relaxed%20smile%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-luna-marrom&orientation=portrait&nocache=true",
      },
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20shoulder%20length%20dark%20hair%20and%20medium%20skin%20wearing%20a%20casual%20matching%20two%20piece%20set%20with%20a%20coordinated%20knit%20top%20and%20knit%20trousers%20in%20the%20same%20fabric%2C%20the%20whole%20set%20is%20clearly%20light%20beige%20colored%2C%20two%20matching%20knit%20garments%2C%20standing%20in%20a%20cozy%20sunlit%20interior%20with%20warm%20beige%20tones%2C%20natural%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20relaxed%20smile%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-luna-bege&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "conjunto-alfaiataria-helena",
    code: "AMB-CON-003",
    name: "Conjunto Alfaiataria Helena",
    categoryId: "conjuntos",
    category: "Conjuntos",
    price: 349.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    isNew: false,
    sold: 63,
    stock: 6,
    description:
      "Blazer e short de alfaiataria em uma dupla poderosa. Perfeito para quem quer elegância com atitude.",
    fabric: "Alfaiataria estruturada",
    fit: "Blazer reto e short de cintura alta",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Preto suave",
        hex: "#2b2320",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20light%20skin%20wearing%20a%20matching%20tailored%20two%20piece%20set%20of%20a%20blazer%20and%20high%20waist%20shorts%2C%20two%20coordinated%20garments%2C%20the%20whole%20set%20is%20clearly%20black%20colored%2C%20the%20shorts%20clearly%20end%20above%20the%20knee%2C%20standing%20in%20a%20modern%20office%20with%20warm%20neutral%20interiors%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-helena-preto&orientation=portrait&nocache=true",
      },
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20straight%20dark%20hair%20and%20light%20skin%20wearing%20a%20matching%20tailored%20two%20piece%20set%20of%20a%20blazer%20and%20high%20waist%20shorts%2C%20two%20coordinated%20garments%2C%20the%20whole%20set%20is%20clearly%20coffee%20brown%20colored%2C%20the%20shorts%20clearly%20end%20above%20the%20knee%2C%20standing%20in%20a%20modern%20office%20with%20warm%20neutral%20interiors%2C%20soft%20daylight%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20confident%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-helena-marrom&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "conjunto-linho-aurora",
    code: "AMB-CON-004",
    name: "Conjunto Linho Aurora",
    categoryId: "conjuntos",
    category: "Conjuntos",
    price: 329.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    isNew: false,
    sold: 71,
    stock: 8,
    description:
      "Linho fresco em um conjunto leve e elegante. Ideal para dias de calor em que você quer estar impecável.",
    fabric: "Linho misto respirável",
    fit: "Camisa solta e short de cintura alta",
    care: "Lavar à mão. Passar levemente úmida.",
    colors: [
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20curly%20hair%20and%20deep%20skin%20wearing%20a%20matching%20linen%20two%20piece%20set%20of%20a%20shirt%20and%20high%20waist%20shorts%20with%20visible%20linen%20texture%2C%20the%20whole%20set%20is%20clearly%20light%20beige%20colored%2C%20two%20coordinated%20garments%2C%20standing%20on%20a%20sunlit%20terrace%20with%20neutral%20walls%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-aurora-bege&orientation=portrait&nocache=true",
      },
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20curly%20hair%20and%20deep%20skin%20wearing%20a%20matching%20linen%20two%20piece%20set%20of%20a%20shirt%20and%20high%20waist%20shorts%20with%20visible%20linen%20texture%2C%20the%20whole%20set%20is%20clearly%20off-white%20cream%20colored%2C%20two%20coordinated%20garments%2C%20standing%20on%20a%20sunlit%20terrace%20with%20neutral%20walls%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-aurora-off&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "conjunto-elegance-valentina",
    code: "AMB-CON-005",
    name: "Conjunto Elegance Valentina",
    categoryId: "conjuntos",
    category: "Conjuntos",
    price: 359.9,
    installments: 3,
    sizes: LETTER_SIZES,
    sizesOut: ["PP"],
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 28,
    stock: 5,
    description:
      "Um conjunto sofisticado para ocasiões que pedem um toque especial. Elegância de sobra em duas peças.",
    fabric: "Crepe encorpado com forro",
    fit: "Blusa com caimento fluido e calça de cintura alta",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20an%20elegant%20matching%20two%20piece%20set%20of%20a%20flowing%20blouse%20and%20high%20waist%20trousers%2C%20two%20coordinated%20garments%2C%20the%20whole%20set%20is%20clearly%20deep%20plum%20ameixa%20purple-burgundy%20colored%2C%20standing%20in%20a%20warm%20sophisticated%20lounge%20with%20neutral%20decor%2C%20soft%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-valentina-ameixa&orientation=portrait&nocache=true",
      },
      {
        name: "Terracota",
        hex: "#a9694f",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20an%20elegant%20matching%20two%20piece%20set%20of%20a%20flowing%20blouse%20and%20high%20waist%20trousers%2C%20two%20coordinated%20garments%2C%20the%20whole%20set%20is%20clearly%20warm%20terracotta%20orange-brown%20colored%2C%20standing%20in%20a%20warm%20sophisticated%20lounge%20with%20neutral%20decor%2C%20soft%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-con-valentina-terracota&orientation=portrait&nocache=true",
      },
    ],
  },

  /* ---------------- SAIAS ---------------- */
  {
    id: "saia-midi-elisa",
    code: "AMB-SAI-001",
    name: "Saia Midi Elisa",
    categoryId: "saias",
    category: "Saias",
    price: 179.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Mais vendido",
    isNew: false,
    sold: 119,
    stock: 10,
    description:
      "Movimento leve e brilho discreto para um look romântico e sofisticado. Uma peça que nunca sai de moda.",
    fabric: "Cetim com toque acetinado",
    fit: "Midi de cintura alta com caimento fluido",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Bege claro",
        hex: "#dcc9ae",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20medium%20skin%20wearing%20a%20midi%20satin%20skirt%20with%20a%20glossy%20shiny%20satin%20surface%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%20with%20a%20knit%20top%2C%20the%20skirt%20is%20clearly%20light%20beige%20colored%20with%20satin%20sheen%2C%20standing%20in%20a%20sunlit%20boutique%20with%20soft%20neutral%20interiors%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20graceful%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-elisa-bege&orientation=portrait&nocache=true",
      },
      {
        name: "Marrom café",
        hex: "#5b4133",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20hair%20and%20medium%20skin%20wearing%20a%20midi%20satin%20skirt%20with%20a%20glossy%20shiny%20satin%20surface%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%20with%20a%20knit%20top%2C%20the%20skirt%20is%20clearly%20coffee%20brown%20colored%20with%20satin%20sheen%2C%20standing%20in%20a%20sunlit%20boutique%20with%20soft%20neutral%20interiors%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20graceful%20pose%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-elisa-marrom&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "saia-plissada-clara",
    code: "AMB-SAI-002",
    name: "Saia Plissada Clara",
    categoryId: "saias",
    category: "Saias",
    price: 169.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    isNew: false,
    sold: 74,
    stock: 9,
    description:
      "Plissado delicado que cria movimento a cada passo. Romântica e cheia de personalidade.",
    fabric: "Tecido plissado leve",
    fit: "Midi plissada de cintura alta",
    care: "Lavar à mão. Não torcer para preservar o plissado.",
    colors: [
      {
        name: "Rosa queimado",
        hex: "#c07862",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20curly%20brown%20hair%20and%20light%20skin%20wearing%20a%20midi%20skirt%20with%20clearly%20visible%20vertical%20accordion%20pleats%20ending%20below%20the%20knee%2C%20one%20single%20separate%20pleated%20skirt%20as%20the%20lower%20garment%20with%20a%20fitted%20top%2C%20the%20skirt%20is%20clearly%20vivid%20burnt%20rose%20pink%20colored%2C%20standing%20in%20a%20bright%20warm%20interior%20with%20neutral%20walls%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-clara-rosa&orientation=portrait&nocache=true",
      },
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20curly%20brown%20hair%20and%20light%20skin%20wearing%20a%20midi%20skirt%20with%20clearly%20visible%20vertical%20accordion%20pleats%20ending%20below%20the%20knee%2C%20one%20single%20separate%20pleated%20skirt%20as%20the%20lower%20garment%20with%20a%20fitted%20top%2C%20the%20skirt%20is%20clearly%20off-white%20cream%20colored%2C%20standing%20in%20a%20bright%20warm%20interior%20with%20neutral%20walls%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-clara-off&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "saia-evase-manuela",
    code: "AMB-SAI-003",
    name: "Saia Evasê Manuela",
    categoryId: "saias",
    category: "Saias",
    price: 189.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    tag: "Destaque",
    isNew: false,
    sold: 81,
    stock: 8,
    description:
      "Modelagem evasê que valoriza a cintura e cria um caimento elegante. Sofisticada sem perder o conforto.",
    fabric: "Crepe fluido com boa caída",
    fit: "Evasê de cintura alta",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20flared%20A%20line%20midi%20skirt%20that%20widens%20gently%20from%20the%20waist%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%20with%20a%20light%20blouse%2C%20the%20skirt%20is%20clearly%20deep%20plum%20ameixa%20purple-burgundy%20colored%2C%20standing%20on%20a%20sunlit%20garden%20path%20with%20warm%20neutral%20tones%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-manuela-ameixa&orientation=portrait&nocache=true",
      },
      {
        name: "Camelo",
        hex: "#b08968",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20dark%20hair%20and%20warm%20medium%20skin%20wearing%20a%20flared%20A%20line%20midi%20skirt%20that%20widens%20gently%20from%20the%20waist%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%20with%20a%20light%20blouse%2C%20the%20skirt%20is%20clearly%20warm%20camel%20brown%20colored%2C%20standing%20on%20a%20sunlit%20garden%20path%20with%20warm%20neutral%20tones%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-manuela-camelo&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "saia-transpassada-sofia",
    code: "AMB-SAI-004",
    name: "Saia Transpassada Sofia",
    categoryId: "saias",
    category: "Saias",
    price: 159.9,
    promoPrice: 129.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizeGroup: "letter",
    isNew: false,
    sold: 57,
    stock: 11,
    description:
      "Transpassada com amarração lateral que marca a cintura com delicadeza. Uma peça prática e cheia de estilo.",
    fabric: "Sarja leve com toque macio",
    fit: "Transpassada midi com amarração",
    care: "Lavar à mão. Passar em temperatura baixa.",
    colors: [
      {
        name: "Off-white",
        hex: "#f1e7da",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20curly%20hair%20and%20deep%20skin%20wearing%20a%20wrap%20midi%20skirt%20with%20an%20overlapping%20front%20panel%20and%20a%20side%20tie%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%2C%20the%20skirt%20is%20clearly%20off-white%20cream%20colored%2C%20standing%20in%20a%20bright%20minimal%20studio%20with%20warm%20neutral%20backdrop%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-sofia-off&orientation=portrait&nocache=true",
      },
      {
        name: "Terracota",
        hex: "#a9694f",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20short%20curly%20hair%20and%20deep%20skin%20wearing%20a%20wrap%20midi%20skirt%20with%20an%20overlapping%20front%20panel%20and%20a%20side%20tie%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%2C%20the%20skirt%20is%20clearly%20warm%20terracotta%20orange-brown%20colored%2C%20standing%20in%20a%20bright%20minimal%20studio%20with%20warm%20neutral%20backdrop%2C%20natural%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-sofia-terracota&orientation=portrait&nocache=true",
      },
    ],
  },
  {
    id: "saia-cetim-serena",
    code: "AMB-SAI-005",
    name: "Saia Cetim Serena",
    categoryId: "saias",
    category: "Saias",
    price: 199.9,
    installments: 2,
    sizes: LETTER_SIZES,
    sizesOut: ["GG"],
    sizeGroup: "letter",
    tag: "Novo",
    isNew: true,
    sold: 24,
    stock: 6,
    description:
      "Cetim com brilho suave e caimento impecável. Perfeita para os momentos em que você quer se sentir especial.",
    fabric: "Cetim com forro",
    fit: "Midi de cintura alta com caimento fluido",
    care: "Lavar à mão ou a seco.",
    colors: [
      {
        name: "Ameixa",
        hex: "#5c2436",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20dark%20hair%20and%20medium%20skin%20wearing%20a%20midi%20satin%20skirt%20with%20a%20glossy%20shiny%20satin%20surface%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%20with%20a%20delicate%20top%2C%20the%20skirt%20is%20clearly%20deep%20plum%20ameixa%20purple-burgundy%20colored%2C%20standing%20in%20an%20elegant%20warm%20hall%20with%20neutral%20decor%2C%20soft%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-serena-ameixa&orientation=portrait&nocache=true",
      },
      {
        name: "Vinho",
        hex: "#6b2338",
        image:
          "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20with%20long%20wavy%20dark%20hair%20and%20medium%20skin%20wearing%20a%20midi%20satin%20skirt%20with%20a%20glossy%20shiny%20satin%20surface%20ending%20below%20the%20knee%2C%20one%20single%20separate%20skirt%20as%20the%20lower%20garment%20with%20a%20delicate%20top%2C%20the%20skirt%20is%20clearly%20rich%20wine%20burgundy%20red%20colored%2C%20standing%20in%20an%20elegant%20warm%20hall%20with%20neutral%20decor%2C%20soft%20light%2C%20realistic%20photographic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=900&seq=amora-sai-serena-vinho&orientation=portrait&nocache=true",
      },
    ],
  },
];

export const productById = (id: string): Product | undefined =>
  products.find((product) => product.id === id);

export const productsByCategory = (categoryId: string): Product[] =>
  products.filter((product) => product.categoryId === categoryId);

export const newProducts = (): Product[] => products.filter((product) => product.isNew);